<template>
  <div
    :id="id"
    class="modal"
    data-backdrop="static"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog" :class="modalSize">
      <div class="modal-content">
        <div v-if="loading" class="absolute w-full h-full bg-black opacity-70">
          <LoadingIcon icon="oval" class="w-8 h-8 text-white" />
        </div>
        <div class="flex items-center pt-2" :class="header ? 'justify-between' : 'justify-end'" v-if="closeButton">
          <h3 class="pl-4 md:pl-10 text-md" v-if="header">{{header}}</h3>
          <button class="btn btn-light border-none shadow-none" @click="hideModal">
            <XIcon class="h-5 w-5" />
          </button>
        </div>
        <div class="modal-body" :class="isBodyPadding ? 'p-4 md:p-10' : 'p-0'">
          <slot></slot>
        </div>
        <slot name="btn">
          <div class="flex flex-row justify-end items-center p-3">
            <button class="btn btn-secondary mr-2" @click="handleClickCancel">
              ยกเลิก
            </button>
            <button class="btn btn-primary" @click="handleClickSave">
              บันทึก
            </button>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

//
<script>
// export default {
//   inheritAttrs: false,
// };
//
</script>

<script setup>
import { onMounted, watch } from "vue";
const props = defineProps({
  modelValue: Boolean,
  id: {
    type: String,
    default: "custom-modal",
  },
  loading: {
    type: Boolean,
    default: false,
  },
  manualHide: {
    type: Boolean,
    default: false,
  },
  closeButton: {
    type: Boolean,
    default: false,
  },
  modalSize: {
    type: String,
    default: 'modal-xl'
  },
  header:{
    type: String,
    default: null
  },
  isBodyPadding:{
    type: Boolean,
    default: true
  }
});
const emits = defineEmits(["update:modelValue", "click:cancel", "click:save"]);

onMounted(() => {
  if (props.modelValue) {
    showModal();
  }
});

watch(
  () => props.modelValue,
  (newval) => {
    if (newval) {
      showModal();
    } else {
      hideModal();
    }
  }
);

const showModal = () => {
  cash(`#${props.id}`).modal("show");
};

const hideModal = () => {
  cash(`#${props.id}`).modal("hide");
    emits("update:modelValue", false);
};

const handleClickCancel = () => {
  if (!props.manualHide) hideModal();
    emits("click:cancel");
};

const handleClickSave = () => {
  if (!props.manualHide) hideModal();
    emits("click:save");
};
</script>
